import React from 'react';
interface LogoProps {
  className?: string;
  variant?: 'dark' | 'light';
}
export function Logo({
  className = '',
  variant = 'dark'
}: LogoProps) {
  const textColor = variant === 'light' ? 'text-white' : 'text-slate-dark';
  const iconColor = variant === 'light' ? 'text-white' : 'text-primary';
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-83">
      <div className={`relative w-8 h-8 ${iconColor}`} data-id="element-84">
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-85">
          <path d="M6 6H26C27.1046 6 28 6.89543 28 8V24C28 25.1046 27.1046 26 26 26H6C4.89543 26 4 25.1046 4 24V8C4 6.89543 4.89543 6 6 6Z" stroke="currentColor" strokeWidth="2" data-id="element-86" />
          <path d="M16 6V26" stroke="currentColor" strokeWidth="2" data-id="element-87" />
          <path d="M8 12H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-88" />
          <path d="M8 16H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-89" />
          <path d="M8 20H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-90" />
          <path d="M20 12H24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-91" />
          <path d="M20 16H24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-92" />
          <path d="M20 20H24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-93" />
          <circle cx="16" cy="16" r="3" fill="currentColor" className="text-accent" data-id="element-94" />
        </svg>
      </div>
      <span className={`font-bold text-xl tracking-tight ${textColor}`} data-id="element-95">
        Bluecore
      </span>
    </div>;
}